import React, { useCallback, useEffect, useState } from "react";
import { PortalStatusTabs } from "../components/PortalStatusTabs";
import { WithdrawalsDataGrid } from "../components/WithdrawalsDataGrid";
import { useLocale } from "../context/LocaleContext";
import { apiFetch } from "../lib/apiClient";
import { showErrorToast } from "../lib/toast";

export function WithdrawalsPage() {
  const { t, dateLocale } = useLocale();
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({ open: 0, today: 0, completed: 0 });
  const [requests, setRequests] = useState([]);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState({ page: 1, per_page: 25, total_count: 0, total_pages: 1 });
  const [statusFilter, setStatusFilter] = useState("");
  const [search, setSearch] = useState("");
  const [searchDebounced, setSearchDebounced] = useState("");

  useEffect(() => {
    const timer = window.setTimeout(() => setSearchDebounced(search), 300);
    return () => window.clearTimeout(timer);
  }, [search]);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ page: String(page), per_page: "25" });
      if (statusFilter) params.set("status", statusFilter);
      if (searchDebounced) params.set("q", searchDebounced);

      const [statsData, listData] = await Promise.all([
        apiFetch("/api/withdrawal_requests/stats"),
        apiFetch(`/api/withdrawal_requests?${params.toString()}`)
      ]);

      setStats(statsData);
      setRequests(listData.withdrawal_requests || []);
      setMeta(listData.meta || meta);
    } catch {
      showErrorToast(t("withdrawals.table.loadError"));
    } finally {
      setLoading(false);
    }
  }, [page, statusFilter, searchDebounced, t]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const statCards = [
    { key: "open", count: stats.open },
    { key: "today", count: stats.today },
    { key: "completed", count: stats.completed }
  ];

  return (
    <div className="portal-page-stack">
      <div className="portal-metrics-grid">
        {statCards.map((card) => (
          <div key={card.key} className="portal-metric-card">
            <p className="portal-metric-card__label">{t(`withdrawals.stats.${card.key}`)}</p>
            <p className="portal-metric-card__value">
              {card.count} {t(`withdrawals.stats.${card.key}Label`)}
            </p>
          </div>
        ))}
      </div>

      <PortalStatusTabs
        active={statusFilter || "all"}
        onChange={(value) => {
          setStatusFilter(value);
          setPage(1);
        }}
      >
        <WithdrawalsDataGrid
          title={t("withdrawals.pageTitle")}
          requests={requests}
          totalCount={meta.total_count}
          loading={loading}
          search={search}
          onSearchChange={(value) => {
            setSearch(value);
            setPage(1);
          }}
          page={page}
          totalPages={meta.total_pages}
          onPageChange={setPage}
          dateLocale={dateLocale}
        />
      </PortalStatusTabs>
    </div>
  );
}
